<template>
  <div class="hero__wrapper">
    <div class="hero__container">
      <div class="hero__left">
        <div class="hero__left-top">
          <p>кастинг платформа</p>
        </div>
        <div class="hero__left-center">
          <h2 class="hero__left-title">
            Почни кар’єру актора –
            <span class="hero__left-title-thin"
            >спробуй себе в зйомках реклами</span
            >
          </h2>
          <p class="hero__left-subtitle">Кастинги знаходять тебе!</p>
          <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeqH_MlJWDVN0OUicbCBT2CMPqYCCc5VqSzXFQw7Eds39FHWQ/viewform"
          ><div class="hero__left-button">Записатися на проби</div></a
          >
        </div>
        <div class="hero__left-bottom">
          <p>Київ</p>
        </div>
      </div>
      <div class="hero__right">
        <video
            class="hero__right-video"
            src="/static/video/hero-talents-1.mp4"
            autoplay
            muted
            playsinline
            loop
            alt="Альт-текст інтро зображення"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hero-block',
}
</script>

<style lang="scss">
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.hero {
  &__wrapper {
    max-width: 1440px;
    margin: 42px auto 0;
    width: 100%;
    height: calc(100vh - 42px);
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 100%;
    align-items: stretch;
  }

  &__left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 6px);

    &-top {
      display: flex;
      height: 45px;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      border-top: 1px solid #0000004d;
      border-bottom: 1px solid #0000004d;
      p {
        font-family: "Inter", sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0;
        text-transform: uppercase;
      }
    }
    &-center {
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &-title {
      font-family: "Inter", sans-serif;
      max-width: 579px;
      text-align: center;
      font-size: 60px;
      color: #000000;
      font-weight: 500;
      line-height: 60px;
      padding-bottom: 30px;
      letter-spacing: -0.02em;
      &-thin {
        font-family: "Nyght Serif", sans-serif;
        font-weight: 300;
        letter-spacing: -0.02em;
      }
    }

    &-subtitle {
      font-size: 14px;
      font-family: "Inter", sans-serif;
      color: #000000;
      font-weight: 500;
      padding-bottom: 30px;
      text-align: center;
      text-transform: uppercase;
    }

    &-button {
      width: 222px;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "Inter", sans-serif;
      color: #000000;
      background-color: #fcc10f;

      font-weight: 600;
      font-size: 14px;
      border-radius: 8px;

      cursor: pointer;
      text-transform: uppercase;
    }
    &-bottom {
      display: flex;
      height: 45px;
      justify-content: center;
      align-items: center;
      border-top: 1px solid #0000004d;
      border-bottom: 1px solid #0000004d;
      font-family: "Inter", sans-serif;
      text-transform: uppercase;
      p {
        font-family: "Inter", sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        text-transform: uppercase;
        letter-spacing: 0;
      }
    }
  }

  &__right {
    width: 100%;
    height: 100%;
    &-video {
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }
  }
  @media (max-width: 914px) {
    &__left-title {
      font-size: 40px;
      line-height: 40px;
    }
  }
}
@media (max-width: 650px) {
  .hero {
    &__container {
      grid-template-columns: repeat(1, 1fr);
      row-gap: 32px;
    }
    &__left-top {
      display: none;
    }
    &__left-bottom {
      display: none;
    }
    &__wrapper {
      margin: 70px auto 0;
      height: 100%;
    }
  }
}
</style>
